<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    hide-price-assessments-tab
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  SILICON_ANODE,
  MARKET,
  SUBSCRIPTION_FORECASTS_SILICON_ANODE,
} from '~/constants/services/constants'
import siliconAnodeData from '~/constants/data-reports/silicon-anode'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(SILICON_ANODE)
const productData = ref(siliconAnodeData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_SILICON_ANODE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${SILICON_ANODE.name} Data and Reports`,
})
useHead(seo)
</script>
